import axios from 'axios';

export const getAgents = (query) => {
    let { service_name } = query;
    let queryString = '';

    if (service_name) {
        queryString = `service_name=${service_name}`;
    }
    
    return axios.get(`${getApiUrl()}/api/agent/all?${queryString}`);
}

export const updateAgent = async (data) => {
  try {
    const response = await axios.post(`${getApiUrl()}/api/agent/update`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
}; 

export const agentService = {
    getAgents,
    updateAgent
}